Core.Page.SetCache = function() {
    this.Cache = {
        productDetail: document.querySelector('#product-detail'),
        productListing: document.querySelector('#product-listing'),
        compare: document.querySelector('#compare'),
        cart: document.querySelector('#cart'),
        dashboard: document.querySelector('#dashboard'),
        portalCheckout: document.querySelector('#portal-checkout'),
        portalPlayoutCart: document.querySelector('#cart-playout'),
        portalLogin: document.querySelector('#portal-login'),
        clientAddressBook: document.querySelector('#client-address-book'),
        newsEventDetails: document.querySelector('#news-event-details'),
        newsEventListing: document.querySelector('#news-event-listing'),
        storeFinder: document.querySelector('#store-finder'),
        storeDetails: document.querySelector('#store-details'),
        myAccount: document.querySelector('#my-account'),
        login: document.querySelector('#login'),
        register: document.querySelector('#register'),
        xform: document.querySelector('.xform'),
        editDetails: document.querySelector('#edit-details'),
        editPassword: document.querySelector('#edit-password'),
        editEmail: document.querySelector('#edit-email'),
        myQuotes: document.querySelector('#my-quote'),
        myRentals: document.querySelector('#my-rental'),
        myTrials: document.querySelector('#my-trial'),
        gallery: document.querySelector('.productgalleryblock'),
        finalisePayment: document.querySelector('.finalisePayment'),
        fileUploadList: document.querySelectorAll('.fileUpload'),
        deliveryCounter: document.querySelector('.deliveryCounter'),
        checkoutAvoidDuplicate: document.querySelector('.checkoutAvoidDuplicate'),
        mapList: document.querySelectorAll('.mapItem'),
        myAccountSupplierInstaller: document.querySelector('.myAccountSupplierInstaller'),
        mfaLogin: document.querySelector('.mfaLogin'),
    };
};

Core.Page.init = function(){
    Core.Util.addIEClasses($('body'));
    Core.Util.isOnMouse();

    this.SetCache();

    /**
     * @see productDetail.js
     */
    if (this.Cache.productDetail) {
        Core.ProductDetail.init();
    }

    /**
     * @see cart.js
     */
    if (this.Cache.cart) {
        Core.Cart.init();
    }

    /**
     * @see dashboard.js
     */
    if (this.Cache.dashboard) {
        Core.Dashboard.init();
    }

    /**
     * @see portalCheckout.js
     * @see portalCheckout.js
     */
    if (this.Cache.portalCheckout) {
        Core.PortalAccordion.init();
        Core.PortalCheckout.init();
        Core.PortalCheckoutCheckboxToggle.init();
        Core.PortalPickupStores.Locator.init();
        Core.PortalCheckoutClientSearch(document.querySelector('[data-client-search]'));
    }

    /**
     * @see portalCheckout.js
     */

    if (this.Cache.portalPlayoutCart) {
        Core.PortalPlayoutCart.init();
        Core.CartFlyout.init();
    }


    /**
     * @see portalLogin.js
     */
    if (this.Cache.portalLogin) {
       Core.PortalLogin.init();
    }

    /**
     * @see clientAddressBook.js
     */
    if (this.Cache.clientAddressBook) {
        Core.ClientAddressBook.init();
    }

    //image & 360 gallery
    if (this.Cache.gallery) {
        Core.Config.ProductDetail.Gallery.MaxSlides = 3;
        Core.ProductDetail.init();
    }

    /**
     * @see productCompare.js
     */
    if (this.Cache.compare) {
        Core.ProductCompare.init();
    }

    /**
     * @see newsEvents.js
     */
    if (this.Cache.newsEventListing) {
        Core.NewsEvents.Listing();
    }

    if (this.Cache.newsEventDetails) {
        Core.NewsEvents.Details();
    }

    /**
     * @see stores.js
     */
    if (this.Cache.storeFinder) {
        Core.Stores.Locator.init();
    }

    if (this.Cache.storeDetails) {
        Core.Stores.Details.init();
    }

    /**
     * @see account.js
     */
    if (this.Cache.myAccount) {
        Core.Account.myAccount();
    }

    if (this.Cache.editDetails || this.Cache.editPassword || this.Cache.editEmail || this.Cache.login || this.Cache.register || this.Cache.xform) {
        Core.Account.form();
    }

    if (this.Cache.myQuotes){
        Core.Account.dataTable('/account/quotes', 'Quote ID', false);
    }

    if (this.Cache.myRentals){
        Core.Account.dataTable('/account/rentals', 'Rental ID', false);
    }

    if (this.Cache.myTrials){
        Core.Account.dataTable('/account/trials', 'Trial ID', true);
    }

    /**
     * @see finalisePayment.js
     */
    if (this.Cache.finalisePayment) {
        Core.FinalisePayment.init();
    }

    /**
     * @see fileUpload.js
     */
    if (this.Cache.fileUploadList && this.Cache.fileUploadList.length > 0) {
        for (var i = this.Cache.fileUploadList.length - 1; i >= 0; i--) {
            new Core.FileUpload(this.Cache.fileUploadList[i]).init();
        }
    }

    /**
     * @see deliveryCounter.js
     */
    if (this.Cache.deliveryCounter) {
        Core.DeliveryCounter(this.Cache.deliveryCounter).init();
    }

    /**
     * @see checkoutAvoidDuplicate.js
     */
    if (this.Cache.checkoutAvoidDuplicate) {
        Core.CheckoutAvoidDuplicate(this.Cache.checkoutAvoidDuplicate).init();
    }

    /**
     * @see map.js
     */
    if (this.Cache.mapList && this.Cache.mapList.length > 0) {
         Core.Map().initList(this.Cache.mapList);
    }

    /**
     * @see myAccountSupplierInstaller.js
     */
    if (this.Cache.myAccountSupplierInstaller) {
         Core.MyAccountSupplierInstaller.init();
    }

    /**
     * @see mfaLogin.js
     */
    if (this.Cache.mfaLogin) {
        Core.MfaLogin().init();
    }
};
